import * as styled from '../styles/social-bios';

export const AnimatedLinkBox = ({
  phase,
  slug,
  enterDelay,
}: {
  phase: Landing.SocialBioPhase;
  slug: string;
  enterDelay?: number;
}) => (
  <styled.AnimatedAlertBox $phase={phase} $enterDelay={enterDelay}>
    <styled.AnimatedAlertPill $phase={phase}>
      {phase === 'good' ? 'New way' : 'Old way'}
    </styled.AnimatedAlertPill>
    <styled.AnimatedAlertText>
      {phase === 'good'
        ? `kudable.com/p/${slug}`
        : `Bookings: ${slug}@gmail.com`}
    </styled.AnimatedAlertText>
  </styled.AnimatedAlertBox>
);
